import React, { useEffect } from "react";
import "./ContactUs.css";
import country from "../../country.json";
import industry from "../../industry.json";

const ContactUs = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
          }
        });
      },
      { 
        threshold: 0,
        rootMargin: "0px 0px -50px 0px"
      }
    );

    const elements = document.querySelectorAll(".contact .animate-side");
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="contact" id="contact">
      <div className="contactlist">
        <div className="contact-list">
          <h1 className="contact-title animate-side slide-left">Contact Us</h1>
          
          <form
            action="https://formsubmit.co/c0a02fa90b88ea3b0b06590b3f2d01fc"
            method="POST"
          >
            <input type="text" name="_honey" style={{ display: "none" }} />
            <input type="hidden" name="_captcha" value="true" />
            <input
              type="hidden"
              name="_autoresponse"
              value="Thank You! We have successfully received your form submission. We appreciate you reaching out and will get back to you as soon as possible. Best regards, DataHarbor Team"
            />
            <input
              type="hidden"
              name="_next"
              value="http://localhost:3000/success"
            />

            <div className="form-group animate-side slide-right row-1">
              <label className="label" htmlFor="firstname">
                First Name
              </label>
              <input type="text" id="firstname" name="firstname" required />
            </div>

            <div className="form-group animate-side slide-left row-2">
              <label className="label" htmlFor="lastname">
                Last Name
              </label>
              <input type="text" id="lastname" name="lastname" required />
            </div>

            <div className="form-group animate-side slide-right row-3">
              <label className="label" htmlFor="email">
                Email Address
              </label>
              <input type="email" id="email" name="email" required />
            </div>

            <div className="form-group animate-side slide-left row-4">
              <label className="label" htmlFor="company">
                Company Name
              </label>
              <input type="text" id="company" name="company" required />
            </div>

            <div className="form-group animate-side slide-right row-5">
              <label className="label" htmlFor="phone">
                Phone Number
              </label>
              <input type="text" id="phone" name="phone" required />
            </div>

            <div className="form-group animate-side slide-left row-6">
              <label className="label" htmlFor="country">
                Country
              </label>
              <select
                autoComplete="country"
                id="country"
                name="country"
                defaultValue=""
                required
              >
                <option value="" disabled>
                  - Please Select -
                </option>
                {country.map((countries) => (
                  <option key={countries.code} value={countries.name}>
                    {countries.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group animate-side slide-right row-7">
              <label className="label" htmlFor="industry">
                Industry
              </label>
              <select id="industry" name="industry" defaultValue="" required>
                <option value="" disabled>
                  - Please Select -
                </option>
                {industry.map((industries) => (
                  <option key={industries.id} value={industries.name}>
                    {industries.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group animate-side slide-left row-8">
              <label className="label" htmlFor="description">
                How can we help you?
              </label>
              <textarea
                name="description"
                id="description"
                className="desc"
                placeholder="Your message..."
                required
              ></textarea>
            </div>

            <button className="btn1 animate-side slide-right row-9" type="submit">
              Submit
            </button>
          </form>
        </div>

        <div className="map-section animate-side slide-right map-row">
          <div className="gmap-frame">
            <iframe
              title="map"
              id="gmap_canvas"
              src="https://maps.google.com/maps?width=100%25&amp;height=400&amp;hl=en&amp;q=Hmais,%20Miziara+(DataHarbor)&amp;t=h&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
            ></iframe>
          </div>
        </div>
      </div>

      <hr className="animate-side slide-left" />

      <div className="contact-office animate-side slide-left">
        <h1 className="contact-title">Our Office</h1>
        <div className="contactinfo">
          <h3>Lebanon</h3>
          <ul>
            <li>DataHarbor Inc.</li>
            <li>Hmais, Miziara</li>
            <li>Zgharta District</li>
            <li>Lebanon</li>
            <li>
              Phone: <a href="tel:+9613105562">+9613105562</a>
              <br />
              <a className="pindent" href="tel:+96171825874">
                +96171825874
              </a>
            </li>
            <li>
              Email:{" "}
              <a href="mailto:info@dataharborlb.com">info@dataharborlb.com</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;